import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {ReactSession} from "react-client-session";
import Navbar from "react-bootstrap/Navbar";
import {Card, Nav} from "react-bootstrap";
import esciLogo from '../img/esci.png';
import documentiLogo from '../img/docacq.png';
import cassaLogo from '../img/cassa.png';
import articoliLogo from '../img/magazzino.png';
import axios from "axios";
import {Button, CardContent, Grid, Typography} from "@mui/material";
import {Cassa} from "./Cassa";
import {loading} from "./loading";
import Permessi from "../Back/Permessi";
import VariabiliGlobali from "../Back/VariabiliGlobali";
import {Documenti} from "./Documenti";
import {Articoli} from "./Articoli";

//todo permessi singoli bottoni in moduli ctrneg
export default function Dashboard() {


    const history = useHistory();
    const idmagazzino = ReactSession.get("idmagazzino");
    const [ragSoc, setRagSoc] = useState();
    const [isLoading, setLoading] = useState(true);
    const [permessiLoaded, setpermessiLoaded] = useState(false);

    useEffect(() => {
        caricapermessi();
        const params = new URLSearchParams();
        params.append('IDASTER', idmagazzino);
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/dammiRagioneSociale';
        axios.post(url, params, config)
            .then((response) => {
                setRagSoc(response.data.Ragione_Sociale);
                setLoading(false);
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(error);
            })
    }, [idmagazzino]);

    function caricapermessi() {
        setpermessiLoaded(false);
        if (permessiLoaded === false) {
            const params = new URLSearchParams();
            params.append('IDASTER', idmagazzino);
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            }
            const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/VerificaPermessi';
            axios.post(url, params, config)
                .then((response) => {
                    try {
                        if (response.data[0].incassi === "1") {
                            Permessi.permessoIncassi = true;
                        }
                        if (response.data[0].artven === "1") {
                            Permessi.permessoArtven = true;

                        }
                        if (response.data[0].contrdoc === "1") {
                            Permessi.permessoContrdoc = true;
                        }
                        if (response.data[0].verart === "1") {
                            Permessi.permessoVerart = true;
                        }
                        if (response.data[0].gestord === "1") {
                            Permessi.permessoGestord = true;
                        }
                        setpermessiLoaded(true);
                        setLoading(false);
                    } catch (e) {
                    }
                })
                .catch((error) => {
                    setpermessiLoaded(true);
                    console.log('Errore: ' + error);
                    alert(error);
                })
        }
    }

    function handleLogout() {
        if (window.confirm('Sei sicuro di voler uscire?')) {
            ReactSession.set("idmagazzino", '0');
            ReactSession.set("loggedIN", false);
            VariabiliGlobali.doveMiTrovo = 'paginaPrincipale'
            history.push("/");
        }

    }

    function paginaPrincipale() {
        VariabiliGlobali.doveMiTrovo = 'paginaPrincipale'
        history.push("/");
    }

    function venduto() {
        VariabiliGlobali.doveMiTrovo = 'venduto'
        history.push("/");
    }

    function documenti() {
        VariabiliGlobali.doveMiTrovo = 'documenti'
        history.push("/");
    }

    function articoli() {
        VariabiliGlobali.doveMiTrovo = 'articoli'
        history.push("/");
    }


    if (isLoading) {
        return (loading())
    }

    return (
        <Grid container direction={"column"}>
            {navbar()}
            {(VariabiliGlobali.doveMiTrovo === 'paginaPrincipale') && (
                <div className="elemento">
                    {home()}
                </div>
            )}
            {VariabiliGlobali.doveMiTrovo === 'venduto' && (
                <div>
                    {Permessi.permessoArtven === true ? (
                        <div className="elemento">
                            <Card className="cardDoveMitrovo" variant="outlined" sx={{minWidth: 275}}>
                                <CardContent className="center">
                                    <img
                                        src={cassaLogo}
                                        className="d-inline-block align-top"
                                        alt=" "
                                    />
                                </CardContent>
                            </Card>
                            <div className="elemento">
                                <Card variant="outlined" sx={{minWidth: 275}}>
                                    <CardContent className="elemento">
                                        {<Cassa/>}
                                    </CardContent>
                                </Card>
                                <br/><br/><br/>
                            </div>
                        </div>
                    ) : (
                        msgNonAbilitato()
                    )}
                </div>
            )}
            {VariabiliGlobali.doveMiTrovo === 'documenti' && (
                <div>
                    {Permessi.permessoContrdoc === true ? (
                        <div className="elemento">
                            <Card className="cardDoveMitrovo" variant="outlined" sx={{minWidth: 275}}>
                                <CardContent className="center">
                                    <img
                                        src={documentiLogo}
                                        className="d-inline-block align-top"
                                        alt=" "
                                    />
                                </CardContent>
                            </Card>
                            <div className="elemento">
                                <Card variant="outlined" sx={{minWidth: 275}}>
                                    <CardContent className="elemento">
                                        {<Documenti/>}
                                    </CardContent>
                                </Card>
                                <br/><br/><br/>
                            </div>
                            <div className="center"><br/><br/><br/>
                            </div>
                        </div>
                    ) : (
                        msgNonAbilitato()
                    )}
                </div>
            )}
            {VariabiliGlobali.doveMiTrovo === 'articoli' && (
                <div>
                    {Permessi.permessoVerart === true ? (
                        <div className="elemento">
                            <Card className="cardDoveMitrovo" variant="outlined" sx={{minWidth: 275}}>
                                <CardContent className="center">
                                    <img
                                        src={articoliLogo}
                                        className="d-inline-block align-top"
                                        alt=" "
                                    />
                                </CardContent>
                            </Card>
                            <div className="elemento">
                                <Card variant="outlined" sx={{minWidth: 275}}>
                                    <CardContent className="elemento">
                                        <Articoli/>
                                    </CardContent>
                                </Card>
                                <br/><br/><br/>
                            </div>
                            <div className="center"><br/><br/><br/>
                            </div>
                        </div>
                    ) : (
                        msgNonAbilitato()
                    )}
                </div>

            )}
        </Grid>
    );

    function msgNonAbilitato() {
        return (
            <Grid className="center" container direction="column" spacing={3}>
                <Grid item>
                    <Card variant="outlined" sx={{minWidth: 275}}>
                        <CardContent className="elemento">
                            <Typography>Modulo non abilitato, contattare Aster Software per l'abilitazione</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        )
    }

    function home() {
        return (
            <Grid container direction="column">
                <Card>
                    <CardContent>
                        <Grid item>
                            <Card>
                                <CardContent>
                                    <h2 className="center">Benvenuto nel Controllo Negozi</h2>
                                </CardContent>
                            </Card>
                        </Grid>
                        <br/>
                        <Grid className="center" item>
                            <h3>Descrizione delle funzioni:</h3>
                        </Grid>
                        <Grid className="center" item>
                            <CardContent className="center">
                                <img className="center"
                                     onClick={venduto}
                                     src={cassaLogo}
                                     alt=" "
                                />
                            </CardContent>
                        </Grid>
                        <Grid className="center" item>
                            <Typography>Consente di consultare il dettaglio del venduto, gli incassi, le operazioni
                                sensibili e i relativi dettagli effettuati sulle postazioni Aster Cash</Typography>
                        </Grid>
                        <br/>
                        <br/>
                        <Grid className="center" item>
                            <CardContent className="center">
                                <img className="center"
                                     onClick={documenti}
                                     src={documentiLogo}
                                     alt=" "
                                />
                            </CardContent>
                        </Grid>
                        <Grid className="center" item>
                            <Typography>Consente di verificare lo stato dei documenti inviati e ricevuti tra magazzino e
                                negozi</Typography>
                        </Grid>
                        <br/>
                        <br/>
                        <Grid className="center" item>
                            <CardContent className="center">
                                <img className="center"
                                     onClick={articoli}
                                     src={articoliLogo}
                                     alt=" "
                                />
                            </CardContent>
                        </Grid>
                        <Grid className="center" item>
                            <Typography>Consente di verificare l'inventario e di confrontare eventuali differenze di
                                prezzi fra magazzino e punti vendita</Typography>
                        </Grid>
                        <br/>
                        <br/>
                    </CardContent>
                </Card>
            </Grid>
        )
    }

    function navbar() {
        return (<div>
            <Navbar collapseOnSelect bg="light" expand="md" className="mb-3">
                <Button variant="outlined" onClick={paginaPrincipale}>{ragSoc} <br/></Button>
                <br/><br/>
                <Navbar.Toggle/>
                <Navbar.Collapse className="justify-content-end">

                    <div className="navdiv">
                        <Nav.Link onClick={venduto}>
                            <img
                                src={cassaLogo}
                                className="d-inline-block align-top"
                                alt=" "
                            /><br/>
                        </Nav.Link>
                    </div>
                    <div className="navdiv">
                        <Nav.Link onClick={documenti}>
                            <img
                                src={documentiLogo}
                                className="d-inline-block align-top"
                                alt=" "
                            /><br/>
                        </Nav.Link>
                    </div>
                    <div className="navdiv">
                        <Nav.Link onClick={articoli}>
                            <img
                                src={articoliLogo}
                                className="d-inline-block align-top"
                                alt=" "
                            /><br/>
                        </Nav.Link>
                    </div>
                    <div className="navdiv">
                        <Nav.Link onClick={handleLogout}>
                            <img
                                src={esciLogo}
                                className="d-inline-block align-top"
                                alt=" "
                            /><br/>
                        </Nav.Link>
                    </div>
                </Navbar.Collapse>
            </Navbar>
        </div>)
    }
}
